import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Паломнический туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Разновидность религиозного туризма, совершаемого верующими людьми разных крнфесий по святым
                        местам.</p>
                    <blockquote>Пилигримы pilgrims - обобщенное наименование странников или путешественников,
                        путешествующих в целях паломничества, паломников.
                    </blockquote>
                    <p>Центрами для развития религиозного туризма являются г.г. Брест, Пинск. Столин, Пружаны, г.п.
                        Ружаны. Важными объектами религиозного туризма являются: Свято-Афанасьевский монастырь (г.
                        Брест), монастырь францисканцев и костел Успения девы Марии (г. Пинск), здание синагоги (г.
                        Столин) и др.</p>
                    <p><a href='https://brestobl.com/turizm/marsh/5.html'>Память земли белорусской</a></p>
                </div>
            </div>
        </>
    );
}